import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
// import Icon from "@material-ui/core/Icon";
import CloudDownload from "@material-ui/icons/CloudDownload";

const styles = theme => ({
  para: {
    fontSize: 16
  },
  button: {
    margin: theme.spacing.unit,
    fontSize: 16
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const Triage = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Rhino3D</Typography>
      <Typography className={classes.para} paragraph>
        I downloaded Rhino 6 from{" "}
        <Link href={"https://www.rhino3d.com/"}>rhino3d.com</Link>. Rhino 6
        Includes{" "}
        <Link href={"https://www.grasshopper3d.com"}>Grasshopper3D</Link>, an
        algorithmic modeling plugin for Rhino. It seems Grasshopper plug-in is
        similar to OpenSCAD but with great visual blocks.
      </Typography>
      <Typography className={classes.para} paragraph>
        Rhino has a lot of tutorials to get started. So, I headed on to{" "}
        <Link href={"https://www.rhino3d.com/tutorials"}>Learn</Link> tab on the
        website homepage. The first step after successful installation and
        license activation is to check/set dimensions for model and layout.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./rhino/Screenshot_1.png"
            alt="Rhino"
          />
        </div>{" "}
        I checked if the unit is millimeters. Then I adjusted Grid settings.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./rhino/Screenshot_2.png"
            alt="Rhino"
          />
        </div>{" "}
        In the first tutorial I got familir with the elements of User Interface
        as 'View Port', 'Pan and Zoom', 'Switching Viewport', 'Status Bar
        Objects (Gumball, GridSnap, Osnap)','Status Bar Checkbox','Commad
        line','Toolbar and Sidebar','Panels' etc.
      </Typography>
      <Typography className={classes.para} paragraph>
        Then I did a modeling tutorial. The object to model was 'Simple Drinking
        Glass'.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./rhino/Screenshot_10.jpg"
            alt="Rhino"
          />
        </div>{" "}
        The tutorial begins by importing a template.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./rhino/Screenshot_4.png"
            alt="Rhino"
          />
        </div>{" "}
        I added a cylinder. Modified dia of top circle using 'gumball'. Removed
        top surface by adding thickness to rest of the surfaces.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./rhino/Screenshot_7.png"
            alt="Rhino"
          />
        </div>{" "}
        I added on more solid box and kept the required part by cutting it. This
        was meant to render 'Water'. So there are essenstially two materials,
        glass and water. Glass was a prebuilt material. I needed create a custom
        material for water, however the refraction index (1.33) was pre-defined
        in the software. <br />
        The following animation demonstrates the final result of modeling.
        <div className={classes.imgdiv}>
          <img className={classes.img} src="./rhino/rhino.gif" alt="Rhino" />
        </div>{" "}
        <Button
          target="_blank"
          href={"./rhino/WaterGlass.3dm"}
          variant="contained"
          size="small"
          color="primary"
          className={classes.button}
        >
          <CloudDownload className={classes.leftIcon} />
          Download file
        </Button>
      </Typography>
      <Typography variant="h5">Grasshopper</Typography>
      <Typography className={classes.para} paragraph>
        Grasshopper is meant for algorithmic modeling in Rhino. I decided to
        make the same object as previous one in Grasshopper to get a comparison
        of modeling experience. I find grasshopper is required when there is
        need for frequent changes in design and to implement 'design intent'.
        <br />
        Design intent is a term used to describe how the model should be created
        and how it should behave when it is changed. With a parametric modeller
        it is very important to plan out the design before modelling. Design
        intent is built into the model according to how dimensions and relations
        are established.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./grasshopper/grasshopper.gif"
            alt="Grasshopper"
          />
        </div>{" "}
        I constructed individual surfaces from curves and baked them to get the
        closed poly-surface.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./grasshopper/grasshopper2.gif"
            alt="Grasshopper"
          />
        </div>{" "}
        I failed to apply material to the object as I could not define the
        poly-surface as single solid body. I wish to further debug the program.
      </Typography>
      <Button
        target="_blank"
        href={"./rhino/grasshopper2.gh"}
        variant="contained"
        size="small"
        color="primary"
        className={classes.button}
      >
        <CloudDownload className={classes.leftIcon} />
        Download file
      </Button>
    </div>
  );
};

export default withStyles(styles)(Triage);
